export const DATE_TIME_FORMAT = "MMM Do YYYY HH:mm";
export const DISABLED_HOURS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 16, 23];
export const CONTACT_US_EMAIL_TEMP = "CONTACT_US_EMAIL_TEMP";
export const RESERVATION_EMAIL_TEMP = "RESERVATION_EMAIL_TEMP";

export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm";
